import { render } from "./TeamForm.vue?vue&type=template&id=4bbf14f3&scoped=true&lang=true"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"

import "./TeamForm.vue?vue&type=style&index=0&id=4bbf14f3&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/oztagaustralia-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbf14f3"]])

export default __exports__